<div id="popover-container" class="cstm-popover-container">
  <button class="btn" (click)="togglePopover(popoverId)">
    <i class="bi bi-three-dots-vertical boton-accion"></i>
  </button>
  <div [id]="'cstm-popover-'+popoverId" class="cstm-popover arrow_box d-none" [ngClass]="'cstm-popover-'+popoverId">
    <ul class="list-group">
      <ng-content></ng-content>
    </ul>
  </div>
</div>